import { render } from "./PlatformDetailsAccessRights.vue?vue&type=template&id=3b653c0e"
import script from "./PlatformDetailsAccessRights.vue?vue&type=script&lang=js"
export * from "./PlatformDetailsAccessRights.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__